import eventObject from '#frontend/dtm/shared/event.js';

/**
 * Purchase dataLayer event
 * @param {object} cart - completed cart object
 * @returns {object} - dataLayer event object
 */
export default (cart) => ({
	event_type: 'purchase',
	...eventObject(cart), // Get all product data
	purchase_id: cart.order.id,
	currencyCode: cart.order.currency
});
